import {
  RetailerShowcaseComponent
} from "@features/leads/retailers/retailer-view/retailer-showcase/retailer-showcase.component";
import {MaterialModule} from "@modules/material.module";
import {AppCoreModule} from "@modules/app.core.module";
import {AppSharedModule} from "@modules/app-shared.module";
import {NgModule} from "@angular/core";

import {AddQuestionsComponent} from "@features/leads/application-form-builder/add-questions/add-questions.component";
import {
  QuestionConfigComponent
} from "@features/leads/application-form-builder/add-questions/question-config/question-config.component";
import {FormStepperComponent} from "@features/leads/application-form-builder/form-stepper/form-stepper.component";
import {
  ManageApplicationFormsComponent
} from '@features/leads/application-form-builder/manage-application-forms/manage-application-forms.component';
import {NameFormComponent} from "@features/leads/application-form-builder/name-form/name-form.component";
import {
  PreviewApplicationFormComponent
} from '@features/leads/application-form-builder/preview-application-form/preview-application-form.component';
import {
  QuestionWeightConfigComponent
} from '@features/leads/application-form-builder/smart-form-configure/question-weight-config/question-weight-config.component';
import {
  SmartFormConfigureComponent
} from '@features/leads/application-form-builder/smart-form-configure/smart-form-configure.component';
import {ApplicationsListComponent} from "@features/leads/applications/applications-list/applications-list.component";
import {
  ApplicantResultsComponent
} from "@features/leads/applications/applications-view/applicant-results/applicant-results.component";
import {ApplicationsViewComponent} from "@features/leads/applications/applications-view/applications-view.component";
import {InterestsListComponent} from "@features/leads/interests/interests-list/interests-list.component";
import {PipelineListComponent} from "@features/leads/pipeline/pipeline-list/pipeline-list.component";
import {PipelineViewComponent} from "@features/leads/pipeline/pipeline-view/pipeline-view.component";
import {
  RetailerBillingDetailsComponent
} from "@features/leads/retailers/retailer-view/retailer-billing-details/retailer-billing-details.component";
import {
  RetailerDetailsComponent
} from "@features/leads/retailers/retailer-view/retailer-details/retailer-details.component";
import {
  RetailerEventsComponent
} from "@features/leads/retailers/retailer-view/retailer-events/retailer-events.component";
import {
  RetailerLeasingHistoryComponent
} from "@features/leads/retailers/retailer-view/retailer-leasing-history/retailer-leasing-history.component";
import {
  RetailerRolesAndPermissionsComponent
} from "@features/leads/retailers/retailer-view/retailer-roles-and-permissions/retailer-roles-and-permissions.component";
import {RetailerViewComponent} from "@features/leads/retailers/retailer-view/retailer-view.component";
import {RetailersListComponent} from "@features/leads/retailers/retailers-list/retailers-list.component";
import {
  CreateARetailerDialogComponent
} from "@features/leads/retailers/create-a-retailer/create-a-lease-dialog/create-a-retailer-dialog.component";
import {CustomDateFilterComponent} from '@ui-kit/webkit/components/custom-date-filter/custom-date-filter.component';
import {ManageSurveysComponent} from "@features/leads/surveys/manage-surveys/manage-surveys.component";
import {SurveyViewComponent} from "@features/leads/surveys/survey-view/survey-view.component";
import {
  SurveyFormBuilderComponent
} from "@features/leads/surveys/survey-view/survey-form-builder/survey-form-builder.component";
import {SurveyResultsComponent} from "@features/leads/surveys/survey-view/survey-results/survey-results.component";
import {
  SurveySubmissionsListComponent
} from "@features/leads/surveys/survey-view/survey-submissions-list/survey-submissions-list.component";
import {FeatureLeasingModule} from "./feature-leasing.module";
import {CrudTableComponent} from "@ui-kit/webkit/components/crud-table/crud-table.component";
import {
  SurveySubmissionViewComponent
} from "@features/leads/surveys/survey-view/survey-submission-view/survey-submission-view.component";
import {
  SurveyFormBuilderQuestionsComponent
} from "@features/leads/surveys/survey-view/survey-form-builder/survey-form-builder-questions/survey-form-builder-questions.component";
import {
  SurveyFormBuilderConfigureSmartFormComponent
} from "@features/leads/surveys/survey-view/survey-form-builder/survey-form-builder-configure-smart-form/survey-form-builder-configure-smart-form.component";
import {
  SurveyDetailsComponent
} from "@features/leads/surveys/survey-view/survey-form-builder/survey-details/survey-details.component";
import {
  SurveyQRCodeConfigurationComponent
} from "@features/leads/surveys/survey-view/survey-form-builder/survey-qrcode-configuration/survey-qrcode-configuration.component";
import {AsyncPipe} from '@angular/common';
import {IndustrySelectComponent} from "@shared-components/industry-select/industry-select.component";

const components = [
  AddQuestionsComponent,
  ApplicantResultsComponent,
  ApplicationsListComponent,
  ApplicationsViewComponent,
  FormStepperComponent,
  InterestsListComponent,
  ManageApplicationFormsComponent,
  NameFormComponent,
  PipelineListComponent,
  PipelineViewComponent,
  PreviewApplicationFormComponent,
  QuestionConfigComponent,
  QuestionWeightConfigComponent,
  RetailerBillingDetailsComponent,
  RetailerDetailsComponent,
  RetailerEventsComponent,
  RetailerLeasingHistoryComponent,
  RetailerRolesAndPermissionsComponent,
  RetailerViewComponent,
  RetailersListComponent,
  SmartFormConfigureComponent,
  CreateARetailerDialogComponent,
  ManageSurveysComponent,
  SurveyViewComponent,
  SurveyFormBuilderComponent,
  SurveyResultsComponent,
  SurveySubmissionsListComponent,
  SurveySubmissionViewComponent,
  SurveyDetailsComponent,
  SurveyFormBuilderQuestionsComponent,
  SurveyFormBuilderConfigureSmartFormComponent,
  // SurveyQRCodeConfigurationComponent
];

@NgModule({
  imports: [
    MaterialModule,
    AppCoreModule,
    AppSharedModule,
    CustomDateFilterComponent,
    FeatureLeasingModule,
    CrudTableComponent,
    SurveyQRCodeConfigurationComponent,
    AsyncPipe,
    RetailerShowcaseComponent,
    IndustrySelectComponent
  ],
  declarations: [...components],
  exports: [...components],
  providers: []
})
export class FeatureLeadsModule {
}
